import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Login } from './pages/Login';
import { Sidebar } from './components/Sidebar';
import { Dashboard } from './components/Dashboard';
import { LeadScout } from './components/modules/LeadScout';
import { SmartReach } from './components/modules/SmartReach';
import { ReferRocket } from './components/modules/ReferRocket';
import { ConversAI } from './components/modules/ConversAI';
import { Header } from './components/Header';
import { LeadScoutDetails } from './components/modules/LeadScoutDetails';
import { Settings } from './pages/Settings';
function ProtectedRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    isAuthenticated,
    isInitialized
  } = useAuth();
  if (!isInitialized) {
    return null; // or a loading spinner
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace data-id="element-0" />;
  }
  return <>{children}</>;
}
function ProtectedLayout() {
  const [activeModule, setActiveModule] = useState('dashboard');
  const location = useLocation();
  // Update activeModule when navigating to leadscout details
  useEffect(() => {
    if (location.pathname.includes('leadscout')) {
      setActiveModule('leadscout');
    }
  }, [location.pathname]);
  const renderContent = () => {
    switch (activeModule) {
      case 'leadscout':
        return <Routes data-id="element-1">
            <Route path="/" element={<LeadScout data-id="element-3" />} data-id="element-2" />
            <Route path="/leadscout/:id" element={<LeadScoutDetails data-id="element-5" />} data-id="element-4" />
          </Routes>;
      case 'smartreach':
        return <SmartReach data-id="element-6" />;
      case 'referrocket':
        return <ReferRocket data-id="element-7" />;
      case 'conversai':
        return <ConversAI data-id="element-8" />;
      default:
        return <Dashboard setActiveModule={setActiveModule} data-id="element-9" />;
    }
  };
  return <div className="flex h-screen w-full bg-gray-50" data-id="element-10">
      <Sidebar activeModule={activeModule} setActiveModule={setActiveModule} data-id="element-11" />
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-12">
        <Header activeModule={activeModule} data-id="element-13" />
        <main className="flex-1 overflow-y-auto p-6" data-id="element-14">
          <Routes data-id="element-15">
            <Route path="/settings" element={<Settings data-id="element-17" />} data-id="element-16" />
            <Route path="/*" element={renderContent()} data-id="element-18" />
          </Routes>
        </main>
      </div>
    </div>;
}
function AppRoutes() {
  const {
    isAuthenticated
  } = useAuth();
  return <Routes data-id="element-19">
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace data-id="element-21" /> : <Login data-id="element-22" />} data-id="element-20" />
      <Route path="/*" element={<ProtectedRoute data-id="element-24">
            <ProtectedLayout data-id="element-25" />
          </ProtectedRoute>} data-id="element-23" />
    </Routes>;
}
export function App() {
  return <AuthProvider data-id="element-26">
      <BrowserRouter data-id="element-27">
        <AppRoutes data-id="element-28" />
      </BrowserRouter>
    </AuthProvider>;
}